import { useEffect, useState } from "react";

/** Returns `value` delayed by `delayMs` — it only updates once the input has
 * stopped changing for that long. Used to keep fast-typing UI (search inputs)
 * from firing one request per keystroke: the visible input stays instant while
 * the debounced value drives the network query. */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
